<template>
  <div
    class="videos-list"
    v-if="!isLoading"
  >
    <InputSearch v-model="searchInput" />

    <div
      class="videos-list__videos"
      v-if="results.length"
    >
      <ul>
        <li>
          <ListSorter
            :columns="columns"
            @changed="sort = $event; searchResult()"
          />
        </li>
        <li
          v-for="(item, index) in results"
          :key="index"
        >
          <a
            href="javascript:"
            @click.prevent="play(item.file)"
          >
            <strong>{{ item.id }}</strong> {{ item.name }}
          </a>
        </li>
      </ul>
    </div>

    <EmptyState
      v-else
      :query="searchInput"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'ListVideos',

  inject: ['searchItems'],

  data () {
    return {
      items: [],
      searchInput: '',
      columns: [
        {
          classes: 'w-16 justify-center',
          name: 'id'
        },
        {
          name: 'name'
        }
      ],
      sort: {
        column: null,
        direction: 0
      },
      results: []
    }
  },

  computed: {
    ...mapState('global', ['isLoading'])
  },

  watch: {
    searchInput (next) {
      if (next.length > 2 || next.length === 0) {
        this.searchResult()
      }
    }
  },

  methods: {
    ...mapMutations('global', ['SET_IS_LOADING']),
    ...mapMutations('videos', ['SET_VIDEO_PLAYING']),

    setItems (data) {
      this.items = data
    },

    fetchData () {
      const api = process.env.VUE_APP_API
      const url = `${api}/videos.json`

      this.SET_IS_LOADING(true)

      axios
        .get(url)
        .then((response) => {
          this.setItems(response.data)
          this.searchResult()
        })
        .catch((error) => {
          throw error
        })
        .then(() => {
          this.SET_IS_LOADING(false)
        })
    },

    play (video) {
      this.SET_VIDEO_PLAYING(video)
    },

    searchResult () {
      this.results = []
      const query = this.searchInput.toLowerCase().trim()
      const items = this.items
      let result = this.searchItems(items, query) || []
      if (this.sort.column) {
        result = result.sort((a, b) => {
          const first = this.sort.direction < 0 ? a : b
          const second = this.sort.direction < 0 ? b : a
          if (this.sort.column === 'name') {
            return first.name
              .toLowerCase()
              .trim()
              .localeCompare(second.name.trim().toLowerCase())
          } else {
            return first.id - second.id
          }
        })
      }

      this.isSorting = false
      this.results = result
    }
  },

  mounted () {
    this.fetchData()
  }
}
</script>

<style lang='scss' scoped>
.videos-list {
  &__videos {
    a {
      display: flex;
      align-items: flex-start;
      padding: 10px;
      outline: 0;
      color: nth($color-custom, 1);
      font-size: 0.9rem;
      line-height: 140%;

      &:focus,
      &:hover {
        background: nth($color-custom, 1);
        color: #fff;
      }

      strong {
        display: inline-block;
        width: 60px;
        margin-right: 15px;
        text-align: right;
      }
    }

    // Responsiveness
    @include media(map-get($breakpoint, 'medium')) {
      a {
        font-size: 0.8rem;

        strong {
          width: 50px;
        }
      }
    }
  }
}
</style>
